import { useEffect, useState, useRef, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Checkbox, Label, Textarea, TextInput, Button } from "flowbite-react";
import { useForm, Controller } from "react-hook-form";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { FechasInterface } from "../../../../../interfaces/FechasInterface";
import { useGetData } from "../../../../../hooks/useGetData";
import { useMutationData } from "../../../../../hooks/useMutationData";
import { Loading } from "../../../../../components/Loading/Loading";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import SkyClear from "../../../../../img/SkyClear.png";
import { ApiKeyMaps } from "../../../../../apis/apis";
import Header from "../../../../../components/HeaderForms/HeaderForms";
import axios from "axios";
import { API } from "../../../../../global/global";
import { ThemeContext } from "../../../../../components/ThemeContext/ThemeContext";

export const CroquisCrearScreen = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const tituloFormulario = "CROQUIS DOMICILIO";
  const navigate = useNavigate();
  const { reset } = useForm();
  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const [edad, setEdad] = useState<number | null>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [images, setImages] = useState<string[]>([""]);
  const [fechaNacimiento, setFechaNacimiento] = useState<string>("");
  const mapRef = useRef<google.maps.Map | null>(null);
  const [mapCenter, setMapCenter] = useState({
    lat: 19.4269903,
    lng: -99.1676463,
  });
  const [markerPosition, setMarkerPosition] = useState<{
    lat: number;
    lng: number;
  } | null>(null);
  const [mapImageUrl, setMapImageUrl] = useState<string | null>(null);
  const token = localStorage.getItem("token");
  const [isMapLoaded, setIsMapLoaded] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [localImageUrl, setLocalImageUrl] = useState<string | null>(null);

  const [formData, setFormData] = useState({
    date: "",
    name: "",
  });

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const queryFecha = useGetData<FechasInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado", "fecha-visita-bienesinmuebles"],
  });

  const domicilio = `${queryEvaluado.data?.calle || ""}, ${
    queryEvaluado.data?.numero_exterior || ""
  }, ${queryEvaluado.data?.colonia || ""}, ${
    queryEvaluado.data?.codigo_postal || ""
  }, ${queryEvaluado.data?.municipio || ""}, ${
    queryEvaluado.data?.estado || ""
  }, ${queryEvaluado.data?.pais || ""}`;

  const mutateFecha = useMutationData({
    url: `/evaluado/${evaluadosList_id}/fecha-visita-bienesinmuebles`,
    reload: ["evaluado", `${evaluadosList_id}`, "fecha-visita-bienesinmuebles"],
  });

  const uploadMapImage = async (imageUrl: string) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        alert("No estás autenticado. Por favor, inicia sesión.");
        return;
      }

      const response = await fetch(imageUrl);
      const blob = await response.blob();

      const formData = new FormData();
      formData.append("image", blob, "Croquis.png");

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      };

      const responseUpload = await axios.post(
        `${API}/evaluados/${evaluadosList_id}/upload-map-image`,
        formData,
        config
      );

      console.log("Imagen subida exitosamente:", responseUpload.data);
      alert("Imagen subida exitosamente");
    } catch (error) {
      console.error("Error al subir la imagen:", error);
      alert("Hubo un problema al subir la imagen.");
    }
  };

  const uploadLocalImage = async (file: File) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        alert("No estás autenticado. Por favor, inicia sesión.");
        return;
      }

      // Crear un objeto URL para mostrar la imagen en la UI
      const localUrl = URL.createObjectURL(file);
      setLocalImageUrl(localUrl);
      setMapImageUrl(localUrl); // Usamos la misma variable para mostrar la imagen

      const formData = new FormData();
      formData.append("image", file, "Croquis.png");

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      };

      const responseUpload = await axios.post(
        `${API}/evaluados/${evaluadosList_id}/upload-map-image`,
        formData,
        config
      );

      console.log("Imagen local subida exitosamente:", responseUpload.data);
      alert("Imagen local subida exitosamente");
    } catch (error) {
      console.error("Error al subir la imagen local:", error);
      alert("Hubo un problema al subir la imagen local.");
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      // Verificar si el archivo es una imagen
      if (file.type.startsWith("image/")) {
        uploadLocalImage(file);
      } else {
        alert("Por favor, seleccione un archivo de imagen válido.");
      }
    }
  };

  const handleUploadClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const getCoordinates = async (address: string) => {
    try {
      const response = await axios.get(
        `https://maps.googleapis.com/maps/api/geocode/json`,
        {
          params: {
            address: address,
            key: ApiKeyMaps,
          },
        }
      );

      if (response.data.results && response.data.results.length > 0) {
        const location = response.data.results[0].geometry.location;
        setMapCenter({ lat: location.lat, lng: location.lng });
        setMarkerPosition({ lat: location.lat, lng: location.lng });
      } else {
        console.warn(
          "No se encontraron resultados para la dirección:",
          address
        );
        console.log("Respuesta de la API:", response.data);
      }
    } catch (error) {
      console.error("Error al obtener las coordenadas:", error);
    }
  };

  const handleMapClick = (event: google.maps.MapMouseEvent) => {
    if (event.latLng) {
      const newLat = event.latLng.lat();
      const newLng = event.latLng.lng();
      setMarkerPosition({ lat: newLat, lng: newLng });
      setMapCenter({ lat: newLat, lng: newLng });
    }
  };

  const captureMapImage = () => {
    console.log("Botón de captura presionado.");
    if (!mapCenter.lat || !mapCenter.lng) {
      console.log("No hay coordenadas de mapa disponibles.");
      return;
    }

    const url = `https://maps.googleapis.com/maps/api/staticmap?center=${mapCenter.lat},${mapCenter.lng}&zoom=16&size=600x400&maptype=roadmap&markers=color:red%7C${mapCenter.lat},${mapCenter.lng}&key=${ApiKeyMaps}`;
    console.log("URL de la imagen capturada:", url);
    setMapImageUrl(url);
    setLocalImageUrl(null); // Limpiar la imagen local si existiera

    uploadMapImage(url);
  };

  const handleSearchCoordinates = () => {
    getCoordinates(domicilio);
  };

  const calcularEdad = (fechaNacimiento: string) => {
    const fechaNac = new Date(fechaNacimiento);
    const hoy = new Date();
    let edadCalculada = hoy.getFullYear() - fechaNac.getFullYear();
    const mes = hoy.getMonth() - fechaNac.getMonth();

    if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNac.getDate())) {
      edadCalculada--;
    }

    return edadCalculada;
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handlePageChange = (newPage: number) => {
    const filledImages = images.filter((image) => image);
    setImages(filledImages.length > 0 ? filledImages : [""]);
    setCurrentPage(newPage);
  };

  const { control, handleSubmit } = useForm();

  const handlePrint = () => {
    const printContent = document.getElementById("printableContent");

    if (printContent) {
      const printWindow = window.open("", "", "width=800,height=600");

      if (printWindow) {
        printWindow.document.write(`
          <html>
            <head>
              <title>Vista Previa de Impresión</title>
              <style>
                @media print {
                  body {
                    margin: 20px;
                    font-family: Arial, sans-serif;
                  }
                }
              </style>
            </head>
            <body>${printContent.innerHTML}</body>
          </html>
        `);

        const styles = document.styleSheets;
        for (let i = 0; i < styles.length; i++) {
          try {
            if (styles[i].cssRules) {
              const styleTag = printWindow.document.createElement("style");
              for (let j = 0; j < styles[i].cssRules.length; j++) {
                styleTag.appendChild(
                  printWindow.document.createTextNode(
                    styles[i].cssRules[j].cssText
                  )
                );
              }
              printWindow.document.head.appendChild(styleTag);
            }
          } catch (e) {
            console.warn("No se pudo copiar una hoja de estilo:", e);
          }
        }

        printWindow.document.close();
        printWindow.onload = () => {
          setTimeout(() => {
            printWindow.print();
            printWindow.close();
          }, 500);
        };
      } else {
        alert("No se pudo abrir la ventana de impresión.");
      }
    }
  };

  const renderHeader = () => (
    <>
      <Header titulo={tituloFormulario} />
    </>
  );

  const generoMap: { [key: string]: string } = {
    M: "Masculino",
    F: "Femenino",
    O: "Otro",
  };

  const generoTexto =
    generoMap[queryEvaluado.data?.genero as string] || "No especificado";

  const mapContainerStyle = {
    width: "100%",
    height: "400px",
  };

  const center = {
    lat: 19.4269903,
    lng: -99.1676463,
  };

  useEffect(() => {
    if (mapRef.current) {
      const advancedMarker = new google.maps.marker.AdvancedMarkerElement({
        position: center,
        map: mapRef.current,
        title: "Ubicación central",
      });
    }
  }, [mapRef]);

  useEffect(() => {
    if (queryEvaluado.data) {
      const fechaNac = queryEvaluado.data.fecha_nacimiento || "";
      setFechaNacimiento(fechaNac);

      const nuevaEdad = calcularEdad(fechaNac);
      setEdad(nuevaEdad);

      reset({
        nombre: queryEvaluado.data.nombre || "",
        apellido_paterno: queryEvaluado.data.apellido_paterno || "",
        apellido_materno: queryEvaluado.data.apellido_materno || "",
        rfc: queryEvaluado.data.rfc || "",
        genero: queryEvaluado.data.genero || "",
        estado_civil: queryEvaluado.data.estado_civil || "",
        escolaridad: queryEvaluado.data.escolaridad || "",
        fecha_nacimiento: fechaNac,
        curp: queryEvaluado.data.curp || "",
        empresa: queryEvaluado.data.empresa?.nombre || "",
      });
    }
  }, [queryEvaluado.data, reset]);

  if (queryEvaluado.isLoading) {
    return <Loading />;
  }

  const renderPage1 = () => (
    <div className={`space-y-4 p-4 ${isDarkMode ? "bg-gray-800" : "bg-white"}`}>
      <div className="grid grid-cols-3 gap-4">
        <div className="col-span-1 flex items-center">
          <Label htmlFor="fecha_croquis" className={`mr-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
            FECHA VISITA:
          </Label>
          <Controller
            name="fecha_croquis"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextInput
                id="fecha_croquis"
                type="date"
                placeholder="Seleccionar fecha"
                {...field}
                className={`w-32 ${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "bg-white text-gray-800 border-gray-300"}`}
              />
            )}
          />
        </div>
        <div className="col-span-2">
          <Label htmlFor="nombre" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>NOMBRE:</Label>
          <TextInput
            id="nombre"
            name="nombre"
            value={`${queryEvaluado.data?.nombre || ""} ${
              queryEvaluado.data?.apellido_paterno || ""
            } ${queryEvaluado.data?.apellido_materno || ""}`}
            onChange={handleInputChange}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "bg-gray-100 text-gray-800 border-gray-300"}`}
          />
        </div>
        <div className="col-span-1">
          <Label htmlFor="rfc" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>RFC:</Label>
          <TextInput
            id="rfc"
            name="rfc"
            onChange={handleInputChange}
            value={queryEvaluado.data?.rfc || ""}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "bg-gray-100 text-gray-800 border-gray-300"}`}
          />
        </div>
        <div className="col-span-1">
          <Label htmlFor="edad" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>EDAD:</Label>
          <TextInput
            id="edad"
            name="edad"
            value={edad !== null ? edad.toString() : ""}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "bg-gray-100 text-gray-800 border-gray-300"}`}
          />
        </div>
        <div className="col-span-1">
          <Label htmlFor="sexo" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>SEXO:</Label>
          <TextInput
            id="sexo"
            name="sexo"
            onChange={handleInputChange}
            value={generoTexto}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "bg-gray-100 text-gray-800 border-gray-300"}`}
          />
        </div>
        <div className="col-span-1">
          <Label htmlFor="estadoCivil" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>ESTADO CIVIL:</Label>
          <TextInput
            id="estadoCivil"
            name="estadoCivil"
            onChange={handleInputChange}
            value={queryEvaluado.data?.estado_civil || ""}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "bg-gray-100 text-gray-800 border-gray-300"}`}
          />
        </div>
        <div className="col-span-1">
          <Label htmlFor="escolaridad" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>ESCOLARIDAD:</Label>
          <TextInput
            id="escolaridad"
            name="escolaridad"
            onChange={handleInputChange}
            value={queryEvaluado.data?.escolaridad || ""}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "bg-gray-100 text-gray-800 border-gray-300"}`}
          />
        </div>
        <div className="col-span-1 flex items-center">
          <Label htmlFor="fechaNacimiento" className={`mr-2 ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>
            FECHA DE NACIMIENTO:
          </Label>
          <TextInput
            id="fechaNacimiento"
            name="fechaNacimiento"
            value={queryEvaluado.data?.fecha_nacimiento || ""}
            disabled={true}
            type="date"
            className={`w-32 ${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "bg-gray-100 text-gray-800 border-gray-300"}`}
          />
        </div>
        <div className="col-span-1">
          <Label htmlFor="curp" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>CURP:</Label>
          <TextInput
            id="curp"
            name="curp"
            onChange={handleInputChange}
            value={queryEvaluado.data?.curp || ""}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "bg-gray-100 text-gray-800 border-gray-300"}`}
          />
        </div>
        <div className="col-span-1">
          <Label htmlFor="empresa" className={`${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>EMPRESA:</Label>
          <TextInput
            id="empresa_id"
            name="empresa"
            value={queryEvaluado.data?.empresa_id?.nombre || ""}
            onChange={handleInputChange}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "bg-gray-100 text-gray-800 border-gray-300"}`}
          />
        </div>
      </div>
    </div>
  );

 const renderPage2 = () => (
    <div className={`space-y-4 p-4 ${isDarkMode ? "bg-gray-800 text-gray-300" : "bg-white text-gray-800"}`}>
      <h2 className={`text-lg font-semibold mb-4 ${isDarkMode ? "text-white" : "text-gray-900"}`}>
        Ubicación en el Mapa
      </h2>
      <TextInput
        id="domicilio"
        name="domicilio"
        onChange={handleInputChange}
        value={domicilio}
        disabled={true}
        className={`${isDarkMode ? "bg-gray-700 text-gray-300 border-gray-600" : "bg-gray-100 text-gray-800"}`}
      />
      <Button
        color="blue"
        onClick={handleSearchCoordinates}
        className={`mt-2 ${isDarkMode ? "bg-blue-600 hover:bg-blue-700 text-white" : "bg-blue-500 text-white"}`}
      >
        Buscar
      </Button>

      <LoadScript
        googleMapsApiKey={`${ApiKeyMaps}`}
        onLoad={() => setIsMapLoaded(true)}
        loadingElement={
          <div className="flex flex-col justify-center items-center h-96 gap-2 text-gray-600">
            <p className={`text-lg font-medium ${isDarkMode ? "text-gray-300" : "text-gray-800"}`}>Cargando mapa interactivo</p>
            <p className={`text-sm text-gray-500 ${isDarkMode ? "text-gray-400" : "text-gray-600"}`}>
              Por favor espere un momento.
              {window.navigator.onLine
                ? " Si la carga se prolonga, intente refrescar la página."
                : "Verifique su conexión a internet."}
            </p>
            {!window.navigator.onLine && (
              <button
                onClick={() => window.location.reload()}
                className={`mt-2 px-4 py-2 rounded transition ${isDarkMode ? "bg-blue-600 text-white hover:bg-blue-700" : "bg-blue-100 text-blue-600 hover:bg-blue-200"}`}
              >
                Reintentar
              </button>
            )}
          </div>
        }
      >
        {isMapLoaded && (
          <GoogleMap
            mapContainerStyle={{ width: "100%", height: "400px" }}
            center={mapCenter}
            zoom={16}
            onLoad={(map) => {
              mapRef.current = map;
              setIsMapLoaded(true);
            }}
            onClick={handleMapClick}
          >
            {markerPosition && (
              <Marker position={markerPosition} title="Ubicación buscada" />
            )}
          </GoogleMap>
        )}
      </LoadScript>

      <div className="flex justify-center mt-4 space-x-4">
        <Button
          color="green"
          onClick={captureMapImage}
          className={`${isDarkMode ? "bg-green-600 hover:bg-green-700 text-white" : "bg-green-500 text-white"}`}
        >
          Capturar Imagen del Mapa
        </Button>
        
        {/* Input para cargar imagen local (oculto) */}
        <input
          type="file"
          ref={fileInputRef}
          onChange={handleFileChange}
          accept="image/*"
          className="hidden"
        />
        
        {/* Botón para activar la carga de archivo */}
        <Button
          color="purple"
          onClick={handleUploadClick}
          className={`${isDarkMode ? "bg-purple-600 hover:bg-purple-700 text-white" : "bg-purple-500 text-white"}`}
        >
          Cargar Imagen Local
        </Button>
      </div>

      {mapImageUrl && (
        <div className="mt-4">
          <h3 className={`text-lg font-semibold ${isDarkMode ? "text-white" : "text-gray-900"}`}>
            {localImageUrl ? "Imagen Local Cargada" : "Captura del Mapa"}
          </h3>
          <div className="flex justify-center mt-2">
            <img
              src={mapImageUrl}
              alt={localImageUrl ? "Imagen Local" : "Captura del Mapa"}
              className={`border rounded mt-2 max-h-96 object-contain ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
            />
          </div>
          <Button
            color="blue"
            className={`mt-4 mx-auto block ${isDarkMode ? "bg-blue-600 hover:bg-blue-700 text-white" : "bg-blue-500 text-white"}`}
            onClick={() => {
              const link = document.createElement("a");
              link.href = mapImageUrl;
              link.download = `croquis_${evaluadosList_id}_${
                new Date().toISOString().split("T")[0]
              }.png`;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }}
          >
            Descargar Imagen
          </Button>
        </div>
      )}
    </div>
  );

  return (
    <div className={`min-h-screen ${isDarkMode ? "bg-gray-900" : "bg-gray-50"}`}>
      <div className={`container mx-auto p-4`}>
        <form
          onSubmit={handleSubmit((data) => {
            console.log("Datos enviados:", data);
            mutateFecha.mutate(
              {
                data: { fecha_croquis: data.fecha_croquis },
                tipo: "put",
              },
              {
                onSuccess: () => navigate(`/domiciliaria/${evaluadosList_id}`),
                onError: (error) => console.error("Error en la mutación:", error),
              }
            );
          })}
          className={`max-w-4xl mx-auto rounded-lg shadow-lg overflow-hidden ${isDarkMode ? "bg-gray-800" : "bg-white"}`}
        >
          {renderHeader()}

          {currentPage === 1 && renderPage1()}
          {currentPage === 2 && renderPage2()}

          <div className="mt-6 p-4 flex justify-between">
            {currentPage === 1 && (
              <Button
                color="red"
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(`/domiciliaria/${evaluadosList_id}`);
                }}
                className={`ml-2 ${isDarkMode ? "bg-red-600 hover:bg-red-700 text-white" : "bg-red-500 text-white"}`}
              >
                Cancelar
              </Button>
            )}

            {currentPage === 1 && (
              <button
                type="button"
                className={`rounded px-4 py-2 ${isDarkMode ? "bg-blue-600 hover:bg-blue-700 text-white" : "bg-blue-500 text-white"}`}
                onClick={() => {
                  window.scrollTo(0, 0);
                  handlePageChange(currentPage + 1);
                }}
              >
                Siguiente
              </button>
            )}

            {currentPage > 1 && (
              <Button
                onClick={() => {
                  window.scrollTo(0, 0);
                  handlePageChange(currentPage - 1);
                }}
                className={`${isDarkMode ? "bg-violet-600 hover:bg-violet-900 text-white" : "bg-violet-500 text-white"}`}
              >
                Anterior
              </Button>
            )}

            {currentPage === 2 && (
              <div className="flex space-x-4">
                <button
                  type="submit"
                  className={`rounded px-4 py-2 ${isDarkMode ? "bg-green-600 hover:bg-green-700 text-white" : "bg-green-500 text-white"}`}
                >
                  Guardar
                </button>
              </div>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};